import React, { FC, MouseEvent, SyntheticEvent } from 'react';
import sanitizeHtml from 'xss';
import { Button, ButtonSizes, ButtonStyles } from '@quantum/ui-atoms';
import { Choice } from '@/machines/types';
import * as styles from './styles.module.scss';

interface TextProps {
  htmlString: string;
  choice: Choice;
  onClick: (event: MouseEvent<HTMLAnchorElement> | SyntheticEvent<HTMLButtonElement>) => void;
}

export const TextQuestion: FC<TextProps> = ({ htmlString, choice, onClick }) => (
  <div className={styles.textQuestionContainer}>
    <div className={styles.textDecoration} dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlString) }} />
    <div className={styles.buttonShadow} />
    <div className={styles.buttonWrapper}>
      <div className={styles.button}>
        <Button
          animate
          fullWidth
          buttonStyle={ButtonStyles.primary}
          size={ButtonSizes.large}
          text={choice.text}
          onClick={onClick}
        />
      </div>
    </div>
  </div>
);
